import * as React from 'react';
import { FC } from 'react';

import NumberOfPortions from './components/NumberOfPortions';
import KeepScreenAwake from './components/KeepScreenAwake';
import Ingredients from './components/IngredientsLists';

interface RecipeIngredientsModel {
    numberOfPortions: number,
    ingredientLists: [],
    whiteIcons?: boolean,
    isKids?: boolean,
}

const RecipeIngredients: FC<RecipeIngredientsModel> = (props) => {
    const [portions, setPortions] = React.useState(props.numberOfPortions)

    return (
        <>
            {props.numberOfPortions !== 0 && (
                <NumberOfPortions portions={portions} setPortions={setPortions} whiteIcons={props.whiteIcons} isKids={props.isKids} />
            )}

            <KeepScreenAwake isKids={props.isKids}/>

            {props.ingredientLists.length > 0 && (
                <Ingredients ingredientLists={props.ingredientLists} portions={portions} defaultPortions={props.numberOfPortions}/>
            )}

        </>
    );
};
export default RecipeIngredients;
